function launchIntoFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
  const scenarioContent = document.getElementsByClassName('scenario__content')[0];
  scenarioContent.classList.add('scorm-resize');
  setTimeout(() => {
    scenarioContent.classList.remove('scorm-resize');
  }, 250);
}

window.FullScreenAPI = {
  launchIntoFullscreen,
  exitFullscreen,
}
